import { observable, action, computed, runInAction, decorate, reaction } from 'mobx';
import agent from '../api/agent';
import { toast } from 'react-toastify';
import { RootStore } from './RootStore';
import { DocumentQuestionFormValues, IDocumentQuestion } from '../models/AdminDocumentQuestion';

const LIMIT = 50;

export default class AdminDocumentQuestionStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore
    reaction(
      () => this.predicate.keys(),
      () => {
        this.page = 0;
        this.AdminDocumentQuestionRegistry.clear();
      }
    )
  }

  AdminDocumentQuestionRegistry = new Map();
  AdminDocumentQuestion: IDocumentQuestion | null = null;
  loadingInitial = false;
  submitting = false;
  target = "";

  AdminDocumentQuestionCount = 0;
  page = 0;

  predicate = new Map();

  setPredicate = (predicate: string, value: string | Date) => {
    this.predicate.clear();
    if (predicate !== 'My Notes') {
      this.predicate.set(predicate, value);
    } else {
      this.predicate.set('createdById', this.rootStore.userStore.user?.id)
    }
  }

  get axiosParams() {
    const params = new URLSearchParams();
    params.append('limit', String(LIMIT));
    params.append('offset', `${this.page ? this.page * LIMIT : 0}`);
    this.predicate.forEach((value, key) => {
      if (key === 'dateCreated') {
        params.append(key, value.toDateString());
      } else {
        params.append(key, value);
      }
    })
    return params;
  }

  get totalPages() {
    return Math.ceil(this.AdminDocumentQuestionCount / LIMIT);
  }

  setPage = (page: number) => {
    this.page = page;
  }

  get AdminDocumentQuestions() {
    return Array.from(this.AdminDocumentQuestionRegistry.values());
  };



  loadAdminDocumentQuestions = async (id: string) => {
    this.loadingInitial = true;
    try {

      this.setPredicate("documentId", id);

      const AdminDocumentQuestionEnvelope = await agent.AdminDocumentQuestion.list(this.axiosParams);
      const { documentTypeDocumentQuestionsDTO, documentTypeDocumentQuestionCount } = AdminDocumentQuestionEnvelope;

      runInAction('loadAdminSettings', () => {
        documentTypeDocumentQuestionsDTO.forEach((documentQuestionDTO) => {
          this.AdminDocumentQuestionRegistry.set(documentQuestionDTO.documentQuestionId, documentQuestionDTO);
        });
        this.AdminDocumentQuestionCount = documentTypeDocumentQuestionCount;
      });

    } catch (error) {
      throw error;
    }
    runInAction('loadAdminSettings', () => {
      this.loadingInitial = false;
    });
  };

  deleteDocumentQuestion = async (documentId: string, questionId: string) => {
    this.submitting = true;
    try {
      await agent.AdminDocumentQuestion.delete(documentId, questionId);

      runInAction('deleteDocumentQuestion', () => {
        this.submitting = false;
        this.AdminDocumentQuestionRegistry.delete(questionId);
      });
      toast.success('deleted');

    } catch (error) {
      runInAction('deleteDocumentQuestion error', () => {
        this.submitting = false;
      });
      toast.error('Problem submitting data');
    }
  };


  createAdminDocumentQuestion = async (adminDocument: DocumentQuestionFormValues) => {
    this.submitting = true;
    try {
      const newRequirements: string = await agent.AdminDocumentQuestion.create(adminDocument);

      toast.success('Saved');
      runInAction('createAdminDocument', () => {
        this.AdminDocumentQuestionRegistry.clear();
        this.submitting = false;

      });
      await this.loadAdminDocumentQuestions(adminDocument.documentTypeId);
    } catch (error) {
      runInAction('createAdminDocument error', () => {
        this.submitting = false;
      });
      toast.error('Problem submitting data');
    }
  };

  editAdminDocumentQuestion = async (adminDocument: DocumentQuestionFormValues) => {
    this.submitting = true;
    try {
      await agent.AdminDocumentQuestion.update(adminDocument);
      runInAction('editAdminDocument', () => {
        this.submitting = false;
      });
      toast.success('Saved');
      this.AdminDocumentQuestionRegistry.set(adminDocument.documentQuestionId, adminDocument);

    } catch (error) {
      runInAction('editAdminDocument error', () => {
        this.submitting = false;
      });
      toast.error('Problem submitting data');
    }
  };



}
decorate(AdminDocumentQuestionStore, {
  AdminDocumentQuestionRegistry: observable,
  AdminDocumentQuestion: observable,
  loadingInitial: observable,
  submitting: observable,
  target: observable,
  AdminDocumentQuestionCount: observable,
  page: observable,
  predicate: observable,

  loadAdminDocumentQuestions: action,
  setPredicate: action,
  setPage: action,
  deleteDocumentQuestion: action,
  editAdminDocumentQuestion: action,

  AdminDocumentQuestions: computed,
  axiosParams: computed,
  totalPages: computed
});